import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { TpoLoanSummaryComponent, TpoBorrowerComponent, TpoClosingInfoComponent, TpoLoanDetailComponent, TpoLoanStatusComponent, TpoOriginationInfoComponent } from ".";
import { LoanStatusCardComponent } from "../widgets/loan-status-card/loan-status-card.component";
import { OutstandingConditionsCardComponent } from "../widgets/outstanding-conditions-card/outstanding-conditions-card.component";
import { TpoLoanSummaryV2Component } from './tpo-loan-summary-v2/tpo-loan-summary-v2.component';
import { CustomDataInfoModule } from "src/app/modules/custom-data-info/custom-data-info.module";
import { ExternalContactsV2Module } from "src/app/modules/external-contacts-v2/external-contacts-v2.module";
import { TpoLoanSummaryReverseComponent } from './reverse/tpo-loan-summary-reverse/tpo-loan-summary-reverse.component';
import { TpoLoanDetailReverseComponent } from "./reverse/tpo-loan-detail-reverse/tpo-loan-detail-reverse.component";
import { KeyDatesModule } from "src/app/modules/key-dates/key-dates.module";
import { EsignatureModule } from "src/app/modules/esignature/esignature.module";
import { TpoEsignatureHistoryComponent } from "../tpo-esignature-history/tpo-esignature-history.component";

@NgModule({
  imports: [
    SharedModule,
    CustomDataInfoModule,
    ExternalContactsV2Module,
    KeyDatesModule,
    EsignatureModule
  ],
  declarations: [
    TpoLoanSummaryComponent,
    TpoBorrowerComponent,
    TpoClosingInfoComponent,
    TpoLoanDetailComponent,
    TpoLoanStatusComponent,
    TpoOriginationInfoComponent,
    LoanStatusCardComponent,
    OutstandingConditionsCardComponent,
    TpoLoanSummaryV2Component,
    TpoLoanDetailReverseComponent,
    TpoLoanSummaryReverseComponent,
    TpoEsignatureHistoryComponent
  ],
  exports: [
    TpoLoanSummaryComponent,
    TpoBorrowerComponent,
    TpoClosingInfoComponent,
    TpoLoanDetailComponent,
    TpoLoanStatusComponent,
    TpoOriginationInfoComponent,
    TpoLoanSummaryV2Component,
    TpoLoanSummaryReverseComponent
  ],
  providers: []
})
export class TpoLoanSummaryModule {
  constructor() {
  }
}
